export default "__VITE_ASSET__JaScB1CFutOi5bzoQ8DDJQ__"